/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_DescriptionInputs */

const en_settings_apikeys_description = /** @type {(inputs: Settings_Apikeys_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your API keys for programmatic access`)
};

/**
* | output |
* | --- |
* | "Manage your API keys for programmatic access" |
*
* @param {Settings_Apikeys_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_description = /** @type {((inputs?: Settings_Apikeys_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_description(inputs)
});
export { settings_apikeys_description as "settings.apikeys.description" }